import { red } from "vuetify/util/colors";

export const customLightTheme = {
    dark: false,
    colors: {
      primary: '#fa9500', 
      secondary: '#132b3f', 
      error: '#c13b33',
      errorLight: '#FFD1D1',
      light: "#ffffff",
      background: '#F8F4F1', 
      highlight: '#f2f2f2', 
      drawer: '#fafafa', 
      success: '#79ab21', 
      warning: '#F5A200', 
    
      'light-blue': '#c8d8e7',
      'light-red': '#fbe0e0',
      'light-yellow': '#faedda',
      'light-green': '#e7f6cd',

      blue: '#2c4052',
      red: '#825050',
      yellow: '#837662',
      green: '#727d5e',
    }
  }
